export const Nestfin_Number = "+918800669072";
export const Nestfin_Email = "hello@nestfin.app";

// +918800118508 -- new number

// export const login_tenant_number = "7503016688";
